import React from "react";
import { Link } from "react-router-dom";
import { BEHAVIORAL_PATTERNS_ROUTE, BEHAVIORAL_PATTERNS_TITLE } from "../../constants/routes.js";

const MentalPatternsBackLink = () => (
  <Link to={BEHAVIORAL_PATTERNS_ROUTE} className="mental-patterns__back">
    ← {BEHAVIORAL_PATTERNS_TITLE}
  </Link>
);

export default MentalPatternsBackLink;
